export const enum AsyncServieCallType {
    receive_DeliveryNotes,
    receive_FinancialReports,
    receive_Personalzeiten,
    receive_TAF,
    send_Artikel,
    send_ArtikelList,
    send_Kassendaten,
    send_Kunden,
    send_Stammdaten,
    start_Bestandsaktualisierung
}
